module.exports = __webpack_public_path__ + "static/car_product_1-2fcb4e860135ca6d8544e0759df87da2.jpg";